import {getSelectionData } from "./utils/textAreaUtils"
import { getOSKeyboardModifierKeyString } from './utils/runtime';

const OSKeyboardModifier = getOSKeyboardModifierKeyString();

export const markdownSyntaxFormatters =  {
  bold: {
    icon: () => 'mdi-format-bold',
    label: 'bold',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'B'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '**',
        suffix: '**',
      });
    }
  },
  italic: {
    icon: () => 'mdi-format-italic',
    label: 'italic',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'I'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '*',
        suffix: '*',
      });
    }
  },
  strike: {
    icon: () => 'mdi-format-strikethrough',
    label: 'strike',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'I'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '~~',
        suffix: '~~',
      });
    }
  },
  table: {
    icon: () => 'mdi-table',
    label: 'table',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'B'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '| header | header | header |\n' +
            '| ------ | ------ | ------ |\n' +
            '|        |        |        |\n' +
            '|        |        |        |',
        suffix: '',
      });
    }
  },
  bulletList: {
    icon: () => 'mdi-format-list-bulleted',
    label: 'bulletList',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'I'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '- ',
        suffix: '',
      });
    }
  },
  orderedList: {
    icon: () => 'mdi-format-list-numbered',
    label: 'orderedList',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'I'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '1.',
        suffix: '',
      });
    }
  },
  taskList: {
    icon: () => 'mdi-format-list-checkbox',
    label: 'taskList',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'I'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '- [ ] ',
        suffix: '',
      });
    }
  },
  code: {
    icon: () => 'mdi-code-tags',
    label: 'code',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'I'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '`',
        suffix: '`',
      });
    }
  },
  blockquote: {
    icon: () => 'mdi-format-quote-close',
    label: 'blockquote',
    keyboardShortcut: [`${OSKeyboardModifier}`, 'B'],
    getFormatting: ({ selectionStart, selectionEnd, value }) => {
      return undoOrAddFormattingForInlineSyntax({
        selectionStart,
        selectionEnd,
        value,
        prefix: '> ',
        suffix: '',
      });
    }
  },
}


export const getNewTextAreaValueWithEdits = ({
                                               textAreaValue,
                                               editSelectionStart,
                                               editSelectionEnd,
                                               replaceSelectionWith,
                                             }) =>
    `${textAreaValue.substring(
        0,
        editSelectionStart,
    )}${replaceSelectionWith}${textAreaValue.substring(editSelectionEnd)}`;


function undoOrAddFormattingForInlineSyntax({
                                                     selectionStart,
                                                     selectionEnd,
                                                     value,
                                                     prefix,
                                                     suffix
                                                   }) {


  const { length: prefixLength } = prefix;
  const { length: suffixLength } = suffix;

  const { selectedText, textBeforeSelection, textAfterSelection } =
      getSelectionData({ selectionStart, selectionEnd, value });

  // Check if selected text has prefix/suffix
  const selectedTextAlreadyFormatted =
      selectedText.slice(0, prefixLength) === prefix &&
      selectedText.slice(-1 * suffixLength) === suffix;

  if (selectedTextAlreadyFormatted) {
    return {
      editSelectionStart: selectionStart,
      editSelectionEnd: selectionEnd,
      replaceSelectionWith: selectedText.slice(prefixLength, -1 * suffixLength),
      newCursorStart: selectionStart,
      newCursorEnd: selectionEnd - (prefixLength + suffixLength),
    };
  }

  // Check if immediate surrounding content has prefix/suffix

  const surroundingTextHasFormatting =
      textBeforeSelection.substring(textBeforeSelection.length - prefixLength) ===
      prefix && textAfterSelection.substring(0, suffixLength) === suffix;


  if (surroundingTextHasFormatting) {
    return {
      editSelectionStart: selectionStart - prefixLength,
      editSelectionEnd: selectionEnd + suffixLength,
      replaceSelectionWith: selectedText,
      newCursorStart: selectionStart - prefixLength,
      newCursorEnd: selectionEnd - prefixLength,
    };
  }

  // No formatting to undo - format the selected text
  return {
    editSelectionStart: selectionStart,
    editSelectionEnd: selectionEnd,
    replaceSelectionWith: `${prefix}${selectedText}${suffix}`,
    newCursorStart: selectionStart + prefixLength,
    newCursorEnd: selectionEnd + prefixLength,
  };
}
